import React from 'react';
import { Input, Col, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { getWithExpiry } from '../../utils/localStorage';
import { LocalStorageKeys } from '../../utils/constant';
import _ from 'lodash';

const { Search } = Input;
const { Option } = Select;

const FilterBar = (props) => {
  const storage = getWithExpiry(LocalStorageKeys.order_list);
  // states
  const {
    data,
    textSearch,
    onFilter,
    searchOption,
    justify,
    // showActionBar,
    playholderSearch,
    colTextSearch,
    children,
  } = props;
  const intl = useIntl();

  const createData = (data) => {
    if (data.length) {
      const defaultOption = {
        name: 'name',
        col: 4,
        placeholder: 'Select',
        data: [],
        type: 'multiple',
      };
      return data.map((item) => {
        if (storage?.filter?.filter_name && storage?.filter?.filter_value) {
          const filter_name = storage?.filter?.filter_name;
          const filter_value = storage?.filter?.filter_value;
          if (Array.isArray(filter_name) && Array.isArray(filter_value)) {
            if (item?.name) {
              const index = _.findIndex(
                filter_name,
                (name) => name === item.name,
              );
              if (index !== -1) {
                item['defaultValue'] = filter_value[index];
              }
            }
          }
        }

        return {
          ...defaultOption,
          ...item,
          onChange: (value) => onFilter(value, item.name, ''),
        };
      });
    }
    return [];
  };

  const createElement = (data) => {
    var dataElement = createData(data);
    if (dataElement?.length) {
      return dataElement?.map((item, index) => {
        return index === 0 ? (
          <Col sm={{ span: 4 }} xs={{ span: 24 }} key={index}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={item?.placeholder}
              onChange={item?.onChange}
              style={{ width: '100%' }}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option.children !== 'string') {
                  if (option?.children?.props?.id) {
                    return (
                      intl
                        .formatMessage({ id: option?.children?.props?.id })
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.value
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }
                }
                return (
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              }}
              defaultValue={item?.defaultValue}>
              {item?.data?.length &&
                item?.data?.map((option, i) => {
                  return (
                    <Option
                      key={i}
                      value={
                        option?.id || option?.value
                          ? option?.id || option?.value
                          : ''
                      }>
                      {option?.title || option?.display || option}
                    </Option>
                  );
                })}
            </Select>
          </Col>
        ) : (
          <Col sm={{ span: item?.col }} xs={{ span: 24 }} key={index}>
            <Select
              // mode={item.type}
              showSearch
              placeholder={item?.placeholder}
              onChange={item?.onChange}
              style={{ width: '100%' }}
              allowClear={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                if (typeof option.children !== 'string') {
                  if (option?.children?.props?.id) {
                    return (
                      intl
                        .formatMessage({ id: option?.children?.props?.id })
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  } else {
                    return (
                      option.value
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    );
                  }
                }
                return (
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                );
              }}
              defaultValue={item?.defaultValue}>
              {item?.data?.length &&
                item?.data?.map((option, i) => {
                  return (
                    <Option
                      key={i}
                      value={
                        option?.id || option?.value
                          ? option?.id || option?.value
                          : ''
                      }>
                      {option?.title || option?.display || option}
                    </Option>
                  );
                })}
            </Select>
          </Col>
        );
      });
    }
    return null;
  };

  return (
    <Row type="flex" gutter={[8, 8]} justify={justify}>
      <Col sm={{ span: colTextSearch }} xs={{ span: 24 }}>
        {textSearch ? (
          <Search
            name="search"
            className="txtSearch"
            placeholder={playholderSearch ? playholderSearch : 'Rechercher'}
            allowClear
            onChange={(e) => onFilter(e.target.value, e.target.name, 'search')}
            style={{ width: '100%' }}
            {...searchOption}
            defaultValue={storage?.filter?.keyword}
          />
        ) : null}
      </Col>
      {createElement(data)}
      {children}
    </Row>
  );
};

FilterBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  textSearch: PropTypes.bool,
  onFilter: PropTypes.func,
  searchOption: PropTypes.object,
  justify: PropTypes.oneOf(['start', 'end', 'center', 'space-between']),
  showActionBar: PropTypes.bool,
  colTextSearch: PropTypes.number,
  playholderSearch: PropTypes.string,
};

FilterBar.defaultProps = {
  data: [],
  onFilter: () => {},
  textSearch: true,
  searchOption: {},
  justify: 'start',
  showActionBar: true,
  colTextSearch: 6,
  playholderSearch: null,
};

export default FilterBar;
